<script setup lang="ts">
import { computed, ref } from 'vue'

const props = defineProps<{
  /**
   * Raw base64 JPEG payload, without the data:image/jpeg;base64, prefix.
   */
  posterJpgData?: string
  /**
   * Raw base64 PNG mask payload, without the data:image/png;base64, prefix.
   */
  posterMaskPngData?: string
}>()

//make a random 4 letter string
const randomString = () => {
  return Math.random().toString(36).substring(2, 6)
}

const posterMaskId = ref(`poster-mask-${randomString()}`)
const posterMaskUrl = ref(`url(#${posterMaskId.value})`)

const payloadToDataUrl = (
  value: string | undefined,
  mimeType: 'image/jpeg' | 'image/png',
) => {
  if (!value) return ''
  if (value.startsWith('data:')) return value
  return `data:${mimeType};base64,${value}`
}

const posterSrc = computed(() =>
  payloadToDataUrl(props.posterJpgData, 'image/jpeg'),
)
const maskSrc = computed(() =>
  payloadToDataUrl(props.posterMaskPngData, 'image/png'),
)
</script>

<template>
  <div
    v-if="!maskSrc"
    id="lazy-load-poster"
    slot="poster">
    <img
      id="poster-image"
      :src="posterSrc" />
  </div>
  <div
    v-else
    id="lazy-load-poster"
    slot="poster">
    <svg
      id="poster-svg"
      preserveAspectRatio="xMidYMid"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 640 480"
      class="svg-elem">
      <defs>
        <mask :id="posterMaskId">
          <image
            width="640"
            height="480"
            id="poster-mask-image"
            :href="maskSrc"></image>
        </mask>
      </defs>
      <image
        width="640"
        height="480"
        id="poster-image"
        :href="posterSrc"
        :mask="posterMaskUrl"></image>
    </svg>
  </div>
</template>

<style scoped>
#lazy-load-poster {
  /* transparent background */
  background-color: transparent;
}

#poster-image {
  object-fit: contain;
}
</style>
